import grid from "../../../frontend/src/mixins/grid";

export default grid